import styled, { css } from "styled-components";
import { Color, FontSize, Screen } from 'styles';
import { Field } from 'formik';

export const StyledWrapper = styled.section`
  background-color: ${Color.White};
  padding: 50px 0;
  width: 100%;
`;

export const StyledHeaderWrapper = styled.header`
`;

export const StyledTextWrapper = styled.div`
    padding: 30px 0;
`;

const MediumFormWrapperStyle = css`
  width: 100%;
`;

export const StyledFormWrapper = styled.div`
    margin: 20px auto 0;
    width: 80%;
    
    ${Screen.medium(MediumFormWrapperStyle)}
`;

export const StyledFormFieldWrapper = styled.div`
    padding: 0 0 20px 0;
    position: relative;
    width: 100%;
`;

export const StyledFormField = styled(Field)`
    font-size: ${FontSize.XS};
    padding: 10px;
    width: 100%;
    border: 1px solid ${Color.DarkGray};
    &:focus {
            border: 2px solid ${Color.Orange};
            outline: 0;
        }
    input{
        color: red;
        
        &:focus {
            border: 1px solid ${Color.Orange};
            outline: 0;
        }
`;

export const StyledFormCheckbox = styled(Field)`
  &:checked {
    &:before {
        background-color: ${Color.Orange};
    }
  }
  &:before {
    border: 2px solid ${Color.MediumGray};
    background-color: ${Color.White};
    content: '';
    display: inline-block;
    height: 20px;
    width: 20px;
    margin-top: -7px;
    }
`;

export const StyledMessageBox = styled.div`
    background-color: ${Color.Orange};
    color: ${Color.White};
    display: inline-block;
    font-size: 12px;
    padding: 6px;
    position: absolute;
    right: 7px;
    top: 7px;
`;

export const StyledFormButton = styled.button`
  background-color: ${Color.Black};
  border: 0;
  color: ${Color.White};
  cursor: pointer;
  display: block;
  font-size: ${FontSize.S};
  font-weight: bold;
  text-align: center;
  position: relative;
  padding: 19px 34px;
  
  transition: color 300ms;
  transform: translateZ(0);
  backface-visibility: hidden;
  width: 100%;
  
  &:before {
    content: "";
    position: absolute;
    z-index: -1;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: ${Color.Orange};
    transform: scaleX(1);
    transform-origin: 50%;
    transition-property: transform;
    transition: 300ms ease-out;
  }
  &:hover:before {
    transform: scaleX(0);
  }
`;

export const StyledFormLabel = styled.label`
    span {
        margin-left: 23px;
        padding: 12px 0 26px;
        display: inline-block;
        width: calc(100% - 130px);
        vertical-align: middle;
        padding-top: 22px;
    }
    div {
      top:40px!important;
    }
    a{
      color: ${Color.Orange};
    }
`;

const MediumFormCommunicatStyle = css`
  width: 100%;
`;

export const StyledFormCommunicat = styled.div`
  background-color: ${props=>props.success ? Color.Green : Color.Red};
  color: ${Color.White};
  margin: 0 auto;
  padding: 15px 0;
  text-align: center;
  width: 80%;
  
  ${Screen.medium(MediumFormCommunicatStyle)}
`;


// WEBPACK FOOTER //
// ./src/components/buyForm/buyForm.style.js